import AvatarDoctor from "@shared/assets/icons/doctor.png";
import AvatarNurse from "@shared/assets/user-types/nurse.png";
import AvatarOrganization from "@shared/assets/user-types/organization.png";
import AvatarPatient from "@shared/assets/user-types/patient.png";
import { cn } from "@shared/utils/cn";

import {
  FaHeadset,
  FaQuestion,
  FaUser,
  FaUserDoctor,
  FaUserGear,
  FaUserNurse,
  FaUserTie,
} from "react-icons/fa6";
import { TbBuildingHospital } from "react-icons/tb";

export const UserType = {
  patient: "Patient",
  doctor: "Docteur",
  assistant: "Infirmier",
  midwife: "Sage-femme",
  organization: "Organisation",
  organizationManager: "Manager d'organisation",
};

export const UserTypeIcon = {
  patient: FaUser,
  doctor: FaUserDoctor,
  assistant: FaUserNurse,
  midwife: FaUserNurse,
  organization: TbBuildingHospital,
  organizationManager: TbBuildingHospital,
  dispatchOperator: FaHeadset,
  dispatchManager: FaUserTie,
  admin: FaUserGear,
  DEFAULT: FaQuestion,
};

const Avatar = ({
  avatar,
  className,
}: {
  avatar: string;
  className?: string;
}) => {
  return (
    <img
      src={avatar}
      className={cn(
        "rounded-full bg-primary p-0 size-16   text-white shrink-0 ",
        className
      )}
    />
  );
};

export const UserTypeAvatar = {
  patient: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarPatient} className={className} />
  ),
  doctor: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarDoctor} className={className} />
  ),
  assistant: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarNurse} className={className} />
  ),
  midwife: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarNurse} className={className} />
  ),
  organization: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarOrganization} className={className} />
  ),
  organizationManager: ({ className }: { className?: string }) => (
    <Avatar avatar={AvatarOrganization} className={className} />
  ),
  DEFAULT: () => <Avatar avatar={AvatarPatient} />,
};
